  // For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixData from 'wix-data';
import wixWindow from 'wix-window';

// CHANGE THESE NUMBERS ACCORDING TO THE Y OF THE VERTICALS STRIPS ----------------

// let StripEditor = 479

// let StripStoresY = 6116
// let StripBookY = 7571
// let StripBlogY = 8730
// let StripMusicY = 9693
// let StripPhotoY = 10655
// let StripVideoY = 11654
// let StripEventsY = 12595
// let StripRestY = 13585

// // CHANGE THIS ACCORDING TO StripRest HIGHT ---------------------------------
// let StripRestH = 969

// // --------------------------------------------------------------------------
// let jump = 170

// // --------------------------------------------------------------------------
// let EndOfVerticals= StripRestY + StripRestH - 400
// StripEditor = StripEditor-30; 
// StripStoresY = StripStoresY+320-jump;
// StripBookY = StripBookY-jump
// StripBlogY = StripBlogY-jump
// StripMusicY = StripMusicY-jump
// StripPhotoY = StripPhotoY-jump
// StripVideoY = StripVideoY-jump
// StripEventsY = StripEventsY-jump
// StripRestY = StripRestY-jump


$w.onReady(function () { 
    let formFactor = wixWindow.formFactor;  // "Mobile"
    if (formFactor !== "Mobile") {
        setTimeout(function() { getPos(); }, 100);
    }

});

function verticals (scrollY,start,end,TextBoxNum){
    if ((scrollY > start)&&(scrollY< end)){
                    // ChangeText ($w('#text46').text,$w('#text47').text);
                    $w('#box51').show();
                    $w('#text90').text = $w('#text'+TextBoxNum).text
    }
}

function getPos () {
    wixWindow.getBoundingRect()
    .then( (windowSizeInfo) => {
        let scrollY = windowSizeInfo.scroll.y;
    
        if (scrollY < StripEditor){
            $w('#columnStrip28').hide();
        }
        if (scrollY > StripEditor){
            $w('#columnStrip28').show();
        }
        if (scrollY < (StripStoresY)){
            $w('#box51').hide();
        }
        verticals(scrollY, StripStoresY, StripBookY, 51)//Manage&Grow - Stores
        verticals(scrollY, StripBookY, StripBlogY, 52)//Manage&Grow - Bookings
        verticals(scrollY, StripBlogY, StripMusicY, 56)//Manage&Grow - Blog
        verticals(scrollY, StripMusicY, StripPhotoY, 60)//Manage&Grow - Music
        verticals(scrollY, StripPhotoY, StripVideoY, 64)//Manage&Grow - Photography
        verticals(scrollY, StripVideoY, StripEventsY, 68)//Manage&Grow - video
        verticals(scrollY, StripEventsY, StripRestY, 72)//Manage&Grow - events
        verticals(scrollY, StripRestY, EndOfVerticals, 76)//Manage&Grow - Restaurants
        if ((scrollY > EndOfVerticals)){
            $w('#box51').hide();
            } 
        setTimeout(function() { getPos(); }, 100);
    })
}

export function box_mouseOut(event, $w) {
    console.log(event.target.id)
    let a = event.target.id.substr(6,3);
    console.log(a)
    $w('#vectorImage'+a).src= 'wix:vector://v1/fc5d8c_77f248a407094c2a8a6da235cc925aa7.svg/ar-02.svg';
    $w('#vector'+a).src= 'wix:vector://v1/fc5d8c_7062af97690f41559e0e73e5f5ebd096.svg/black.svg';
    $w('#lineb'+a).show();
    $w('#linec'+a).hide();
}

export function box_mouseIn(event, $w) {
    console.log(event.target.id)
    let a = event.target.id.substr(6,3);
    console.log(a)
    $w('#vectorImage'+a).src= 'wix:vector://v1/fc5d8c_49101c138d6c4dbea6d3c13be91a6087.svg/ar-01.svg';
    $w('#vector'+a).src= 'wix:vector://v1/fc5d8c_fc44cff0a8e747328e0e0a7ca0f2ccc2.svg/blue.svg';
    $w('#lineb'+a).hide();
    $w('#linec'+a).show();
}


export function button133_click(event, $w) {
    if ($w('#box67').hidden){
    $w('#box67').show()}
    else {
       $w('#box67').hide() 
    }
	//Add your code for this event here: 
}

export function box68_mouseOut(event, $w) {
    $w('#box67').hide()
	//Add your code for this event here: 
}

export function button134_click(event, $w) {
    $w('#box67').hide()
	//Add your code for this event here: 
}

export function button135_click(event, $w) {
    $w('#box67').hide()
	//Add your code for this event here: 
}

export function button136_click(event, $w) {
    $w('#box67').hide()
	//Add your code for this event here: 
}

// export function box68_mouseIn(event, $w) {
//      $w('#box67').show()
// 	//Add your code for this event here: 
// }

export function button133_mouseIn(event, $w) {
     $w('#box67').show()
	//Add your code for this event here: 
}




        // if ((scrollY > 732)&&(scrollY<6180)) {
        //     $w('#box51').hide();
        //    }
        // verticals(scrollY, 6180, 7350, 51)//Manage&Grow - Stores
        // verticals(scrollY, 7350, 8510, 52)//Manage&Grow - Bookings
        // verticals(scrollY, 8510, 9430, 56)//Manage&Grow - Blog
        // verticals(scrollY, 9430, 10390, 60)//Manage&Grow - Music
        // verticals(scrollY, 10390, 11350, 64)//Manage&Grow - Photography
        // verticals(scrollY, 11350, 12320, 68)//Manage&Grow - video
        // verticals(scrollY, 12320, 13260, 72)//Manage&Grow - events
        // verticals(scrollY, 13260, 13860, 76)//Manage&Grow - Restaurants
        // if ((scrollY > 13860)&&(scrollY< 16000)){
        //     $w('#box51').hide();
        //     } 



// import {local} from 'wix-storage';
// const diffTimeToRefreshCash = 24 * 60 * 60 * 1000

// let listOfElement = [{"id":'Editor',"filter":'Wix Editor'},
//                      {"id":'ADI',"filter":'Wix ADI'},
//                      {"id":'Code',"filter":'Corvid by Wix'},
//                      {"id":'Pro',"filter":'Professional Features for Your Website'},
//                      {'id':'Stores','filter':'Wix Stores'},
// 					 {'id':'Book','filter':'Wix Bookings '},
//                      {'id':'Blog','filter':'Wix Blog'},
//                      {'id':'Music','filter':'Wix Music'},
//                      {'id':'Photo','filter':'Wix Photography'},
//                      {'id':'Video','filter':'Wix Video'},
//                      {'id':'Events','filter':'Wix Events'},
//                      {'id':'Rest','filter':'Wix Restaurants'},
//                      {'id':'Promote','filter':'Features to Promote'}
                     
//                      ]
                     
// const NameRepeater = "#XXRep"
// const NameHead = "#XXHead"
// const NameText = "#XXText"
// const NameStrip = "#columnStrip"

// async function showElements(){
//     let listOfFeatures = [];    
    
//     let date1 = new Date()
//     console.log(date1.getTime())

//     let diff = 0;
//     let value = local.getItem("Features_Last_Update")
//     if (value !== null){
//         diff = date1.getTime() - parseInt(value, 10)
//     }
//     console.log("diff ",diff)
//     //local.clear()

//     if (diff === 0 || diff > diffTimeToRefreshCash) {
//         await wixData.query("Features")
//         .ascending("order")
//         .limit(1000)
//         .find()
//         .then( (results) => {
//             listOfFeatures = results.items; //see item below
//         } )
//         .catch( (err) => {
//             console.error("Error in quering Features - ",err)
//         } );
//         local.setItem("Features_Last_Update", date1.getTime());
//         local.setItem("Features_List", JSON.stringify(listOfFeatures))

//         console.log("First Time")
//     } else {
//         listOfFeatures=JSON.parse(local.getItem("Features_List"))
//         console.log("Second Time")
//     }

//     let date2 = new Date()
//     console.log(date2)
    
    
//     listOfElement.forEach((tmpElement,index) => {
//         $w(NameRepeater + tmpElement.id).onItemReady(($w, itemData, index_) => {
//             $w(NameHead + tmpElement.id).text = itemData.headlines;
//             $w(NameText + tmpElement.id).text = itemData.text;
//         })

//         setTimeout(() => {
//             $w(NameRepeater + tmpElement.id).data = listOfFeatures.filter((item) => { return item.title === tmpElement.filter});
//             $w(NameRepeater + tmpElement.id).show()
//             $w(NameStrip+tmpElement.id).show()
//         },index*300+50)
//     })
// }

// export function columnStrip23_viewportEnter(event, $w) {
//     $w('#columnStrip28').hide()
// 	//Add your code for this event here: 
// }

// export function columnStrip23_viewportLeave(event, $w) {
//      $w('#columnStrip28').show()
// 	//Add your code for this event here: 
// }
export function button149_mouseIn(event, $w) {
    $w('#box70').show();
	//Add your code for this event here: 
}

export function box70_mouseOut(event, $w) {
    $w('#box70').hide()
	//Add your code for this event here: 
}